const hosts = {
  'rewards-inc.cloud': 'production',
  default: 'development'
};

const configMap = {
  production: {
    baseUrl: 'https://api.rewards-inc.cloud',
    isDevelopment: false,
    serviceUUID: '7f5ddaeb-b2b5-4021-a641-9d6946ee16b3' // TODO replace with production
  },
  development: {
    baseUrl: 'https://dev-api.rewards-inc.cloud',
    isDevelopment: true,
    serviceUUID: '7f5ddaeb-b2b5-4021-a641-9d6946ee16b3'
  }
};

const config = (() => {
  if (typeof location === 'undefined') {
    return configMap[hosts.default];
  }
  const env = hosts[location.hostname] || hosts.default;
  return configMap[env];
})();

export const BASE_URL = config.baseUrl;

export const SERVICE_UUID = config.serviceUUID;

export const IS_DEVELOPMENT = config.isDevelopment || false;

export const CORE_DATA_BASE_URL = `${BASE_URL}/data`;
export const UPDATE_SERVICE_BASE_URL = `${BASE_URL}/updates`;
export const AUTH_BASE_URL = `${BASE_URL}/auth`;
export const COMMUNICATOR_BASE_URL = `${BASE_URL}/comm`;
export const HEALTH_REPORT_BASE_URL = `${BASE_URL}/health-reporting`;
export const LOCATION_DATA_BASE_URL = `${BASE_URL}/location-data`;
export const PUPPETEER_BASE_URL = `${BASE_URL}/puppeteer`;
export const APP_BASE_URL = `${BASE_URL}/app`;
export const PERMISSION_BASE_URL = `${BASE_URL}/permission`;

export const AUTH_URL = `${AUTH_BASE_URL}/username-password-authentication`;
export const AWS_CREDENTIALS_URL = `${AUTH_BASE_URL}/get-aws-credentials`;

export const SUBSCRIBE_COMMUNICATOR_URL = `${COMMUNICATOR_BASE_URL}/subscribe`;
export const PUBLISH_COMMUNICATOR_URL = `${COMMUNICATOR_BASE_URL}/publish`;

export const GEOLOCATION_HEALTH_REPORT_URL = `${HEALTH_REPORT_BASE_URL}/get-geolocation-health-report`;
export const HEALTH_REPORT_URL = `${HEALTH_REPORT_BASE_URL}/get-health-report`;

export const UPDATE_SERVICE_GET_AVAILABLE_UPDATES_URL = `${UPDATE_SERVICE_BASE_URL}/available-updates`;
export const UPDATE_SERVICE_REQUEST_UPDATE_URL = `${UPDATE_SERVICE_BASE_URL}/update/requestUpdate`; // Add /{productUuid} when using

export const LIST_QUEUE_STATUS_URL = `${COMMUNICATOR_BASE_URL}/status`;


export const LOCATION_DATA_GET_SUMMARY_URL = `${LOCATION_DATA_BASE_URL}/get-summary`;
export const LOCATION_DATA_GET_LOCATIONS_URL = `${LOCATION_DATA_BASE_URL}/get-locations`;

export const GENERATE_PDF_URL = `${PUPPETEER_BASE_URL}/generate-pdf`;

export const APP_GRAPHQL = `${APP_BASE_URL}/graphql`;
export const PERMISSION_GRAPHQL = `${PERMISSION_BASE_URL}/graphql`;



// WEBPACK FOOTER //
// ./src/services/config.js